import React from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import dayjs, { Dayjs } from 'dayjs';

export interface FormTimePickerProps {
  name: string;
  label?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  required?: boolean;
  defaultValue?: string;
}

const TIME_FORMAT = 'HH:mm';

export const FormTimePicker: React.FC<FormTimePickerProps> = ({
  name,
  label,
  fullWidth = true,
  size = 'small',
  required,
  defaultValue,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? ''}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const parsed: Dayjs | null = value ? dayjs(value, TIME_FORMAT) : null;
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label={label}
              value={parsed}
              ampm={false}
              views={['hours', 'minutes']}
              format={TIME_FORMAT}
              onChange={(newValue: Dayjs | null) => {
                onChange(newValue ? newValue.format(TIME_FORMAT) : '');
              }}
              slotProps={{
                textField: {
                  fullWidth,
                  size,
                  required,
                  error: !!error,
                  helperText: error?.message,
                },
              }}
            />
          </LocalizationProvider>
        );
      }}
    />
  );
};

export default FormTimePicker;
